module.exports = __webpack_public_path__ + "img/levels-of-detail.fr.6508d343.png";